module.exports = __webpack_public_path__ + "static/img/07.5d4e7e22.png";